module.exports = __webpack_public_path__ + "site/img/39.4682fe95.jpg";